import clsx from 'clsx';

import { Icon } from '@atom/mui';
import colors from '@atom/styles/colors';

import classes from './carousel.module.css';

// These props are injected by react-slick, and should remain defined as follows
interface Props {
  className?: string;
  onClick?: any;
}

const PrevArrow = ({ className, onClick }: Props) => {
  return (
    <div className={className} onClick={onClick}>
      <div className={clsx(classes.arrowContainer, classes.prev)}>
        <Icon color={colors.neutral.black}>keyboard_arrow_left</Icon>
      </div>
    </div>
  );
};

export default PrevArrow;
